import {
  useDynamicContext,
  useSwitchWallet,
  useUserWallets,
  Wallet,
} from '@dynamic-labs/sdk-react-core';

export const useUnlinkWallet = () => {
  const userWallets = useUserWallets();
  const switchWallet = useSwitchWallet();
  const { handleUnlinkWallet: unlinkWallet, primaryWallet } =
    useDynamicContext();

  const handleUnlinkWallet = async (wallet: Wallet) => {
    if (primaryWallet?.address === wallet.address) {
      const newWallet = userWallets.find((w) => w.address !== wallet.address);
      if (newWallet?.id) await switchWallet(newWallet.id);
    }
    await unlinkWallet(wallet.id);
  };

  return { handleUnlinkWallet };
};
